/* eslint-disable react/no-multi-comp */
import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from "react"
import { Link } from "gatsby"
import { Button, GridLines } from "@components/shared"
import { logTool, css, q, featureFlag } from "@jsUtils"
import { CONSTANTS, URLS } from "@data"
import { useLocation } from "@reach/router"
import queryString from "query-string"
import DemoFormContent from "./DemoFormContent"
import Styles from "./demoForm.module.scss"

const { THEMES } = CONSTANTS

const log = logTool()

/**
 * Conditionally wrap the button with a link based on the feature flag
 * @param {object} props - react props
 * @param {array|function} props.children - wrapped react components
 * @param {string} props.linkTo - url to link to
 * @param {boolean} props.useOverlay - use the overlay or the link
 */
const ConditionallyLink = props => {
  const { children, linkTo, useOverlay } = props
  return (
    <>
      {!useOverlay && <Link to={linkTo}>{children}</Link>}
      {useOverlay && <>{children}</>}
    </>
  )
}

/**
 * Demo overlay form wrapper
 * @param {object} props - react props
 */
const DemoForm = forwardRef((props, ref) => {
  const location = useLocation()

  const { color, buttonColor, className, inView } = props
  const [open, setOpen] = useState(false)

  const mainButton = useRef(false)
  const setup = useRef(false)

  const useOverlayForm = featureFlag("exoWorksSupportOverlay")

  const openClose = tf => {
    log("openClose(tf)", tf)
    if (tf) {
      setup.current = true
      q("body").classList.toggle(Styles.openPage)
    } else if (setup.current) {
      log("Demoform cleanup")
      q("body").classList.remove(Styles.openPage)
      mainButton.current.focus()
      setup.current = false
    } else {
      log("init noop")
    }
  }

  const close = () => setOpen(false)

  const onClick = () => {
    log("demoform onClick")
    window.location.href = URLS.BOOK_DEMO
  }

  useImperativeHandle(ref, () => ({
    clickFromOutside() {
      onClick()
    }
  }))

  useEffect(() => {
    setOpen(open)
    openClose(open)
    return () => {
      setOpen(false)
      openClose(false)
    }
  }, [open])

  useEffect(() => {
    if (queryString.parse(location.search).demo) {
      setOpen(true)
    }
  }, [])
  return (
    <>
      <ConditionallyLink useOverlay={useOverlayForm} linkTo={URLS.CONTACT}>
        {inView ? null : (
          <Button
            ascope="CTAS"
            adata="MISC.TRYEXO"
            ref={mainButton}
            className={Styles.demoButton}
            color={buttonColor}
            filled
            onClick={onClick}
            displayCTA
          >
            Book a Demo
          </Button>
        )}
      </ConditionallyLink>
      <div
        className={css(
          Styles.demoForm,
          color && Styles[`color_${color}`],
          open && Styles.open,
          className
        )}
      >
        <div className={Styles.wrapper}>
          <GridLines theme={THEMES.DARK} />
          <DemoFormContent openState={open} openClose={close} />
        </div>
      </div>
    </>
  )
})

export default DemoForm
